import React, { useEffect, useState } from "react";
import "./Sidebar.css";

const Sidebar = ({ onEmployeeClick }) => {
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch(
      "https://www.principleacs.net/LoginApi/public/getAllEmployeesForAttendance"
    )
      .then((res) => res.json())
      .then((data) => {
        if (data && Array.isArray(data.empList)) {
          setEmployees(data.empList);
        }
      })
      .catch((err) => console.error("Error fetching employees:", err));
  }, []);

  // Step 1: Filter based on search
  const filteredEmployees = employees.filter(
    (emp) =>
      emp.empId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      emp.empName.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Step 2: Sort employees by empId ascending
  const sortedEmployees = [...filteredEmployees].sort((a, b) =>
    a.empId.localeCompare(b.empId)
  );

  // Step 3: Move "leftOrg === 'Y'" employees to the end
  const activeEmployees = sortedEmployees.filter((emp) => emp.leftOrg !== "Y");
  const leftEmployees = sortedEmployees.filter((emp) => emp.leftOrg === "Y");

  const finalEmployeeList = [...activeEmployees, ...leftEmployees];

  return (
    <div className="sidebar">
      <input
        type="text"
        placeholder="Search by name or ID"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <h2>Employees List</h2>
      <div className="employee-list">
        {finalEmployeeList.map((emp) => (
          <div
            className="employee-card"
            key={emp.empId}
            onClick={() => onEmployeeClick(emp.empId, emp.empName)}
            style={{ cursor: "pointer" }}
          >
            <h4>{emp.empName}</h4>
            <p>ID: {emp.empId}</p>
            <p style={{ color: emp.leftOrg === "Y" ? "yellow" : "white" }}>
              Status: {emp.leftOrg === "Y" ? "Resigned" : "Active"}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;

//--------------------------employee id based ascending order -------------------------//

// import React, { useEffect, useState } from "react";
// import "./Sidebar.css";

// const Sidebar = ({ onEmployeeClick }) => {
//   const [employees, setEmployees] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     fetch(
//       "https://www.principleacs.net/LoginApi/public/getAllEmployeesForAttendance"
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data && Array.isArray(data.empList)) {
//           setEmployees(data.empList);
//         }
//       })
//       .catch((err) => console.error("Error fetching employees:", err));
//   }, []);

//   const filteredEmployees = employees.filter(
//     (emp) =>
//       emp.empId.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       emp.empName.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="sidebar">
//       <input
//         type="text"
//         placeholder="Search by name or ID"
//         value={searchTerm}
//         onChange={(e) => setSearchTerm(e.target.value)}
//       />
//       <h2>Employees List</h2>
//       <div className="employee-list">
//         {filteredEmployees.map((emp) => (
//           <div
//             className="employee-card"
//             key={emp.empId}
//             onClick={() => onEmployeeClick(emp.empId, emp.empName)}
//             style={{ cursor: "pointer" }}
//           >
//             <h4>{emp.empName}</h4>
//             <p>ID: {emp.empId}</p>
//             <p style={{ color: emp.leftOrg === "Y" ? "Yellow" : "white" }}>
//               Status: {emp.leftOrg}
//             </p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;
//--------------------------------------------------------------------------------------------------//
// import React, { useEffect, useState } from "react";
// import "./Sidebar.css";

// const Sidebar = ({ onEmployeeClick }) => {
//   const [employees, setEmployees] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     fetch(
//       "https://www.principleacs.net/LoginApi/public/getAllEmployeesForAttendance"
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data && Array.isArray(data.empList)) {
//           setEmployees(data.empList);
//         }
//       })
//       .catch((err) => console.error("Error fetching employees:", err));
//   }, []);

//   const filteredEmployees = employees.filter(
//     (emp) =>
//       emp.empId.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       emp.empName.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div className="sidebar">
//       <input
//         type="text"
//         placeholder="Search by name or ID"
//         value={searchTerm}
//         onChange={(e) => setSearchTerm(e.target.value)}
//       />
//       <h2>Employees List</h2>
//       <div className="employee-list">
//         {filteredEmployees.map((emp) => (
//           <div
//             className="employee-card"
//             key={emp.empId}
//             onClick={() => onEmployeeClick(emp.empId)}
//             style={{ cursor: "pointer" }}
//           >
//             <h4>{emp.empName}</h4>
//             <p>ID: {emp.empId}</p>
//             <p style={{ color: emp.leftOrg === "Y" ? "Yellow" : "white" }}>
//               ORG: {emp.leftOrg}
//             </p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

//--------------------perfect code -----------------------------//

// import React, { useEffect, useState } from "react";
// import "./Sidebar.css";
// import axios from "axios";
// // import logo from "./pic.jpg"; // Make sure this file exists

// const Sidebar = () => {
//   const [employees, setEmployees] = useState([]);
//   const [searchId, setSearchId] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     // https://www.principleacs.net/LoginApi/public/getEmployeesList
//     // https://www.principleacs.net/LoginApi/public/getAllEmployeesForAttendance
//     fetch(
//       "https://www.principleacs.net/LoginApi/public/getAllEmployeesForAttendance"
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data && Array.isArray(data.empList)) {
//           setEmployees(data.empList);
//         } else {
//           console.error("Invalid data format", data);
//         }
//       })
//       .catch((err) => console.error("Error fetching employees:", err));
//   }, []);

//   const filteredEmployees = employees
//     .filter(
//       (emp) =>
//         emp.empId.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         emp.empName.toLowerCase().includes(searchTerm.toLowerCase())
//     )
//     .sort((a, b) => a.empId.localeCompare(b.empId));
//   return (
//     <div className="sidebar">
//       <input
//         type="text"
//         placeholder="Search by name or ID"
//         className="search-input"
//         value={searchTerm}
//         onChange={(e) => setSearchTerm(e.target.value)}
//       />

//       <h2>Employees List</h2>

//       <div className="employee-list">
//         {filteredEmployees.map((emp) => (
//           <div className="employee-card" key={emp.empId}>
//             <h4>{emp.empName}</h4>
//             <p>ID: {emp.empId}</p>
//             <p
//               style={{ color: emp.leftOrg === "Y" ? "Yellow" : "white" }}
//               className="empLeftOrg"
//             >
//               ORG: {emp.leftOrg}
//             </p>
//             {/* <p style={{ color: "red" }} className="empLeftOrg">
//               ORG: {emp.leftOrg}
//             </p> */}
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

//--------------------------------------------filter search --------------------//

// import React, { useEffect, useState } from "react";
// import "./Sidebar.css";
// import logo from "./pic.jpg"; // Place your logo image in the `src` folder

// const Sidebar = () => {
//   const [employees, setEmployees] = useState([]);

//   useEffect(() => {
//     fetch("https://www.principleacs.net/LoginApi/public/getEmployeesList")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data && Array.isArray(data.empList)) {
//           setEmployees(data.empList);
//         } else {
//           console.error("Invalid data format", data);
//         }
//       })
//       .catch((err) => console.error("Error fetching employees:", err));
//   }, []);

//   return (
//     <div className="sidebar">
//       {/* <div className="logo-container">
//         <img src={logo} alt="Logo" className="logo" />
//       </div> */}
//       <h2>Employees List</h2>
//       <div className="employee-list">
//         {employees.map((emp) => (
//           <div className="employee-card" key={emp.empId}>
//             <h4>{emp.empName}</h4>
//             <p>ID: {emp.empId}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

//-----------------------------------------------------------------------------------------//
//code is perfect
// import React, { useEffect, useState } from "react";
// import "./Sidebar.css";

// const Sidebar = () => {
//   const [employees, setEmployees] = useState([]);

//   useEffect(() => {
//     fetch("https://www.principleacs.net/LoginApi/public/getEmployeesList")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data && Array.isArray(data.empList)) {
//           setEmployees(data.empList);
//         } else {
//           console.error("Invalid data format", data);
//         }
//       })
//       .catch((err) => console.error("Error fetching employees:", err));
//   }, []);

//   return (
//     <div className="sidebar">
//       <h2>Employees List</h2>
//       <div className="employee-list">
//         {employees.map((emp) => (
//           <div className="employee-card" key={emp.empId}>
//             <h4>{emp.empName}</h4>
//             <p>ID: {emp.empId}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

//--------------------------------------------------------------------------------------//
// import React, { useEffect, useState } from "react";
// import "./Sidebar.css";

// const Sidebar = () => {
//   const [employees, setEmployees] = useState([]);

//   useEffect(() => {
//     fetch("https://www.principleacs.net/LoginApi/public/getEmployeesList")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data && Array.isArray(data.empList)) {
//           setEmployees(data.empList);
//         } else {
//           console.error("Invalid data format", data);
//         }
//       })
//       .catch((err) => console.error("Error fetching employees:", err));
//   }, []);

//   return (
//     <div className="sidebar">
//       <h2>Employees</h2>
//       <ul>
//         {employees.map((emp) => (
//           <li key={emp.empId}>
//             {emp.empName} ({emp.empId})
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default Sidebar;

// import React, { useEffect, useState } from "react";
// import "./Sidebar.css";

// const Sidebar = () => {
//   const [employees, setEmployees] = useState([]);

//   useEffect(() => {
//     fetch("https://www.principleacs.net/LoginApi/public/getEmployeesList")
//       .then((res) => res.json())
//       .then((data) => {
//         if (data && Array.isArray(data.empList)) {
//           setEmployees(data.empList);
//         } else {
//           console.error("Invalid data format", data);
//         }
//       })
//       .catch((err) => console.error("Error fetching employees:", err));
//   }, []);

//   return (
//     <div className="sidebar">
//       <h2>Employees</h2>
//       <ul>
//         {employees.map((emp) => (
//           <li key={emp.empId}>{emp.empName}</li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default Sidebar;
